import { Member, MemberUtils, Season } from "./member.utils.ts";
import { CoursePaymentSummary, PaymentSummary } from "./types.ts";

type CourseSubscriptionInput = {
  subscriber_id: string;
  type: "ski" | "snow";
  level: 1 | 2 | 3 | 4;
};

export type Course = {
  id: string;
  price: number;
};

export const PaymentUtils = {
  calculateSeasonPaymentDetails: (
    members: Member[],
    season: Season
  ): PaymentSummary => {
    const breakdown = members.map((member) => {
      const memberType = MemberUtils.getMemberType(
        member.date_of_birth,
        season
      );
      let amount = 0;

      switch (memberType) {
        case "baby":
          amount = season.cost_kid;
          break;
        case "junior":
          amount = season.cost_kid;
          break;
        case "adult":
          amount = season.cost_adult;
          break;
      }

      return {
        memberId: member.id,
        firstName: member.first_name,
        lastName: member.last_name,
        memberType,
        amount,
      };
    });

    const total = breakdown.reduce((sum, item) => sum + item.amount, 0);

    return {
      breakdown,
      total,
    };
  },

  calculateCoursePaymentDetails: (
    subscriptions: CourseSubscriptionInput[],
    members: Member[],
    course: Course
  ): CoursePaymentSummary => {
    const breakdown = subscriptions.map((subscription) => {
      const member = members.find((m) => m.id === subscription.subscriber_id);

      if (!member) {
        throw new Error(
          `Member not found for subscription: ${subscription.subscriber_id}`
        );
      }

      return {
        memberId: member.id,
        firstName: member.first_name,
        lastName: member.last_name,
        courseType: subscription.type,
        level: subscription.level,
        amount: course.price,
      };
    });

    const total = breakdown.reduce((sum, item) => sum + item.amount, 0);

    return {
      breakdown,
      total,
    };
  },
};
